import { runtimeConfig } from '@/config/runtime-config'
import { createApiClient } from '@/lib/api/http-client'
import { getStoredToken } from '@/lib/auth/token-storage'

interface SuccessEnvelope<T> {
  code: 'success'
  data: T
}

interface OptionalDataEnvelope<T> {
  code: 'success'
  data?: T
  message?: string
}

export interface AdminProfile {
  email: string
  id: string
  name: string
  role?: string | null
  status?: string | null
}

export interface AdminProfileUpdatePayload {
  adminId: string
  name: string
}

export interface AdminPasswordUpdatePayload {
  adminId: string
  currentPassword: string
  newPassword: string
}

const apiClient = createApiClient({
  baseUrl: runtimeConfig.apiBaseUrl,
  getToken: () => getStoredToken('admin'),
  portal: 'admin',
})

export async function updateAdminProfile(values: AdminProfileUpdatePayload) {
  const response = await apiClient.request<SuccessEnvelope<AdminProfile>>(
    `/admin/settings/admins/${encodeURIComponent(values.adminId)}`,
    {
      body: JSON.stringify({
        name: values.name.trim(),
      }),
      method: 'PUT',
    },
  )

  return response.data
}

export async function updateAdminPassword(values: AdminPasswordUpdatePayload) {
  await apiClient.request<OptionalDataEnvelope<{ generated_password?: string }>>(
    `/admin/settings/admins/${encodeURIComponent(values.adminId)}/password`,
    {
      body: JSON.stringify({
        current_password: values.currentPassword,
        new_password: values.newPassword,
      }),
      method: 'PUT',
    },
  )
}
